import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { filter, includes } from 'lodash'
import { FC, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { AssistantShortDTO } from '../../../api/gen/base'
import CircleInformation from '../../../assets/icons/CircleInformation.svg?react'
import Crystal from '../../../assets/icons/Crystal.svg?react'
import PenSquare from '../../../assets/icons/PenSquare.svg?react'
import { AssistantIcon } from '../../../components/AssistantIcon/AssistantIcon'
import { AssistantConnectDialog } from '../../../dialogs/AssistantConnectDialog'
import { AssistantInfoDialog } from '../../../dialogs/AssistantInfoDialog'
import { useProfileStore } from '../../../store/storeProfile'
import { useRequestsStore } from '../../../store/storeRequests'
import { useWrapperStore } from '../../../store/storeWrapper'
import { theme } from '../../../theme'

export interface AssistantCardProps {
    assistant: AssistantShortDTO
    color: string
    colorLight: string
    onClickCard?: (assistantId: string) => void
}

const AssistantCard: FC<AssistantCardProps> = ({ assistant, onClickCard }) => {
    const { pathname } = useLocation()
    const { name, description, agent, id, is_favorite } = assistant || {}
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const [searchParams, setSearchParams] = useSearchParams()
    const [openAssistantInfoDialog, setOpenAssistantInfoDialog] = useState<boolean>(false)
    const [openAssistantConnectDialog, setOpenAssistantConnectDialog] = useState<boolean>(false)
    const {
        setCurrentAgentAndAssistantIdDialog,
        setCurrentAssistantDataInDialog,
        setStateNotification,
        setScrollToRequestInput,
        assistantSubscriptions,
        updateAssistant,
        isLoadingUpdateAssistant
    } = useWrapperStore((state) => state)
    const { requestDetail } = useRequestsStore((state) => state)
    const { userTariff } = useProfileStore()
    const isAvailableByTariff = !!includes(
        userTariff?.tariff?.restrictions?.available_assistants,
        id,
    )
    const availableNameTariff = includes(assistant.available_on_tariffs, 'START')
        ? 'Старт'
        : 'Профи'
    const isAvailableByUse = isAvailableByTariff && assistant.available === 'FREE'
    const isBuy = filter(assistantSubscriptions, { assistant_id: assistant.id }).length > 0

    const handleSubmitAssistantInfoDialog = () => {
        handleOpenAssistantConnectDialog()
        setOpenAssistantInfoDialog(false)
    }

    const handleCloseAssistantInfoDialog = () => {
        setOpenAssistantInfoDialog(false)
    }

    const handleOpenAssistantInfoDialog = () => {
        setOpenAssistantInfoDialog(true)
    }

    const handleSubmitAssistantConnectDialog = () => {}

    const handleCloseAssistantConnectDialog = () => {
        setOpenAssistantConnectDialog(false)
    }

    const handleOpenAssistantConnectDialog = () => {
        setOpenAssistantConnectDialog(true)
    }

    const handleClick = () => {
        setCurrentAgentAndAssistantIdDialog({
            agent,
            assistantId: id,
        })
        setCurrentAssistantDataInDialog(assistant)

        searchParams.set('assistant_id', String(id))

        setSearchParams(searchParams)

        !onClickCard &&
            setStateNotification({
                isOpen: true,
                text: 'Выбор ассистента успешно сохранен! Напишите запрос',
                isError: false,
            })

        setScrollToRequestInput(true)

        onClickCard && onClickCard(String(id))
    }

    const handleClickFavorite = () => {
        updateAssistant(id, {is_favorite: !is_favorite})
    }

    return (
        <Box
            sx={{
                border: '1px solid #E9EAED',
                borderRadius: '16px',
                padding: '16px',
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '260px',
                alignItems: 'left',
            }}>
            <Stack
                direction="row"
                gap="8px"
                sx={{ alignItems: 'center', margin: '0 0 4px', justifyContent: 'space-between' }}>
                <Stack direction="row" gap="4px">
                    <AssistantIcon id={id} />
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '20px',
                            color: ' #1B1C1D',
                        }}>
                        {name}
                    </Typography>
                </Stack>
                <IconButton sx={{ height: '20px', width: '20px' }} disabled={isLoadingUpdateAssistant}>
                    {is_favorite ? (
                        <FavoriteIcon
                            sx={{ color: '#E82C1F', height: '16px', width: '16px' }}
                            onClick={handleClickFavorite}
                        />
                    ) : (
                        <FavoriteBorderIcon
                            sx={{ height: '16px', width: '16px' }}
                            onClick={handleClickFavorite}
                        />
                    )}
                </IconButton>
            </Stack>

            {/*<Collapse*/}
            {/*    collapsedSize="64px"*/}
            {/*    sx={{*/}
            {/*        width: '100%',*/}
            {/*        '& .MuiCollapse-wrapperInner': {*/}
            {/*            overflow: 'hidden',*/}
            {/*            textOverflow: 'ellipsis',*/}
            {/*            display: '-webkit-box',*/}
            {/*            WebkitLineClamp: 2,*/}
            {/*            WebkitBoxOrient: 'vertical',*/}
            {/*        },*/}
            {/*    }}>*/}
            <Typography
                variant="body1"
                mb="12px"
                sx={{ lineHeight: '26px', fontWeight: '400', fontSize: '14px', color: ' #1B1C1D' }}>
                {description}
            </Typography>
            {/*</Collapse>*/}

            {((assistant.available === 'PAID' && isBuy) || assistant.available === 'FREE') && (
                <Stack alignItems="center" direction="row" gap={1} sx={{ marginTop: 'auto' }}>
                    <Button
                        sx={{ gap: '4px' }}
                        fullWidth={true}
                        disabled={
                            (!isAvailableByUse && assistant.available !== 'PAID') ||
                            userTariff?.tariff.tariff_type === 'FREE'
                        }
                        onClick={handleClick}
                        variant="outlined"
                        startIcon={
                            isAvailableByUse || (assistant.available === 'PAID' && isBuy) ? (
                                <PenSquare />
                            ) : (
                                ''
                            )
                        }>
                        {isAvailableByUse || (assistant.available === 'PAID' && isBuy)
                            ? requestDetail
                                ? 'Выбрать'
                                : 'Новый запрос'
                            : `Доступен на уровне «${availableNameTariff}»`}
                    </Button>
                    <IconButton onClick={handleOpenAssistantInfoDialog}>
                        <CircleInformation />
                    </IconButton>
                </Stack>
            )}

            {assistant.available === 'PAID' && !isBuy && (
                <Stack alignItems="center" direction="row" gap={1} sx={{ marginTop: 'auto' }}>
                    <Button
                        sx={{ gap: '4px' }}
                        fullWidth={true}
                        onClick={handleOpenAssistantInfoDialog}
                        variant="outlined"
                        startIcon={<Crystal />}>
                        Возможности ассистента
                    </Button>
                </Stack>
            )}

            {openAssistantInfoDialog && (
                <AssistantInfoDialog
                    isBuy={isBuy}
                    open={openAssistantInfoDialog}
                    handleClose={handleCloseAssistantInfoDialog}
                    handleSubmit={handleSubmitAssistantInfoDialog}
                    handleNewReply={handleClick}
                    assistant={assistant}
                    availableNameTariff={isAvailableByTariff ? '' : availableNameTariff}
                />
            )}
            <AssistantConnectDialog
                handleNewReply={handleClick}
                open={openAssistantConnectDialog}
                handleClose={handleCloseAssistantConnectDialog}
                handleSubmit={handleSubmitAssistantConnectDialog}
                assistant={assistant}
            />
        </Box>
    )
}

export default AssistantCard
